import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getSentOrdersByDate(context, payload) {
        return axios
            .get(`/reports/report-sent-orders-by-date?${payload.query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o wysłanych zamówieniach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getSentOrdersByDateCf(context, payload) {
        return axios
            .get(`/reports/report-sent-orders-by-date-cf?${payload.query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o wysłanych zamówieniach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getWeeklySentOrders(context, payload) {
        return axios
            .get(`/reports/report-sent-orders-by-week-average?${payload.query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o wysłanych zamówieniach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getMonthlySentOrders(context, payload) {
        return axios
            .get(`/reports/report-sent-orders-by-month-average?${payload.query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o wysłanych zamówieniach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    printOrderReport(context, payload) {
        return axios
            .post('/orders/orders/report-card-print', payload, {
                responseType: 'arraybuffer'
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu dla podanego numeru zamówienia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProducts({ commit }) {
        return axios
            .get('/reports/reports/dicts/pm-products')
            .then(response => {
                commit('GET_PRODUCTS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie produktów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setWeeklySentOrdersFilters({ commit }, filters) {
        commit('SET_WEEKLY_SENT_ORDERS_FILTERS', filters)
    },
    clearWeeklySentOrdersFilters({ commit }) {
        commit('CLEAR_WEEKLY_SENT_ORDERS_FILTERS')
    },
    setMonthlySentOrdersFilters({ commit }, filters) {
        commit('SET_MONTHLY_SENT_ORDERS_FILTERS', filters)
    },
    clearMonthlySentOrdersFilters({ commit }) {
        commit('CLEAR_MONTHLY_SENT_ORDERS_FILTERS')
    },
}